import toUpper from 'lodash/toUpper';
export const firstChar = (str: string | null) => {
  return typeof str === 'string' ? toUpper(str.charAt(0)) : null;
}
